import Modal from '../modal/Modal';
import { Account } from '../../types/interfaces/account.interfaces';
import { centsToDollars } from '../../services/account.service';
import { ACCOUNT_CONSTANTS, BUTTON_CONSTANTS, ON_FARM_BILLING_CONSTANTS } from '../../constants/common';
import '../mark-as-paid-modal/markAsPaidModal.scss';

type OnFarmMarkAsPaidModalProps = {
  isOpen: boolean;
  width?: number;
  account?: Account;
  onClose: () => void;
  onConfirm: () => void;
};

const OnFarmMarkAsPaidModal = ({ isOpen, width = 600, account, onClose, onConfirm }: OnFarmMarkAsPaidModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} width={width} ignoreBackdrop>
      <div className="mark-as-paid-modal">
        <div className="header">
          <h4>{ON_FARM_BILLING_CONSTANTS.MARK_AS_PAID}</h4>
        </div>
        <div className="body">
          <div className="body-content">
            <div className="row">
              <div className="l-column">{ACCOUNT_CONSTANTS.ACCOUNT_FARM_NAME}: </div>
              <div className="r-column">
                <b>{account?.name}</b>
              </div>
            </div>
            <div className="row">
              <div className="l-column">{ON_FARM_BILLING_CONSTANTS.ON_FARM_DUE}: </div>
              <div className="r-column">
                <b>${centsToDollars(account?.onFarmOutstandingBalanceCents ?? 0)}</b>
              </div>
            </div>
            <p>{ON_FARM_BILLING_CONSTANTS.MARK_AS_PAID_CONFIRM}</p>
          </div>
        </div>
        <div className="footer">
          <button className="button blue inverted small" onClick={onClose}>
            {BUTTON_CONSTANTS.CANCEL}
          </button>
          <button className="button green small" onClick={onConfirm}>
            {BUTTON_CONSTANTS.YES}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default OnFarmMarkAsPaidModal;
